import Request from '@/plugins/request';

export function getUserLevelApplies(params) {
  return Request.get('user-level-applies', { params })
}

export function createUserLevelApply() {
  return Request.get(`user-level-applies/create`)
}

export function storeUserLevelApply(data) {
  return Request.post('user-level-applies', data)
}

export function updateUserLevelApply(id, data) {
  return Request.put(`user-level-applies/${id}`, data)
}
export function auditUserLevelApply(id, data) {
  return Request.put(`user-level-applies/${id}/audit`, data)
}

export function editUserLevelApply(id) {
  return Request.get(`user-level-applies/${id}/edit`)
}

export function destroyUserLevelApply(id) {
  return Request.delete(`user-level-applies/${id}`)
}

export function exportUserLevelApply(params) {
  return Request.get('user-level-applies/export', { params })
}
